import React, { useEffect, useState } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import { Buffer } from 'buffer'
import MySpiner from '../../../../UI/spiner/MySpiner'
import MyButton from '../../../../UI/form/MyButton'
import { getBoxQrCodesAPI } from '../../../../../api/pack/boxAPI'

const BoxQr = ({ boxId, setOpen, type }) => {

    const [result, setResult] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    useEffect(() => {
        if (result) {
            getFile()
        }
    }, [result])

    const getQrs = () => {
        setError('')
        setLoading (true)
        getBoxQrCodesAPI({ boxId: boxId, type }).then(data => {
            setResult(data)
            setLoading (false)
        }).catch(e => {
            setError(responseError(e))
            setLoading (false)
        })
    }

    const getFile = () => {
        const buffer = Buffer.from(result.file);
        const blob = new Blob([buffer]);

        // const name = type && type === 'barcode' ? "штрих-коди на коробку в партії.zip" : "qr-коди на коробку в партії.zip"
        const name = result.fileName
                                   
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);

        setResult('')

        setOpen(false)
    }

  return (
    <div>
        <p className='packResultBlock__text'>Буде отриманий архів з QR-кодами товарів в середині коробки</p>

        {
            loading ?
                <MySpiner />
            : ''
        }

        {
            error ?
                <div className='error'>
                    { error }
                </div>
            : ''
        }

        <MyButton
            size='md'
            onClick={getQrs}
            disabled={loading ? true : false}
        >
            Отримати QR-коди
        </MyButton>
    </div>
  )
}

export default BoxQr